import { Stack, Grid, Chip, Badge, Button } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useOutletContext, useParams} from "react-router-dom";
import moment from 'moment/moment';
import 'moment/locale/it';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BookPopup from 'src/components/stComponents/BookPopup';
import SteLib, {POPUP_INITDATA} from 'src/lib/stelib';
import MovieIcon from '@mui/icons-material/MovieOutlined';

var accessTimeIconStyle = {
  fontSize: "1rem",
  marginBottom: "-.1rem"
}

var movieIconStyle = {
  fontSize: "1rem",
  marginBottom: "-.25rem"
}

export default function MovieDetailsPage() {
    const [firstTime, setFirstTime] = useState(true);
    const [isMobile, loading] = useOutletContext();
    const [movie, setMovie] = useState({});
    const [windowInWidth, setWindowInWidth] = useState(window.innerWidth);
    const [BP_data, BP_setData] = useState(POPUP_INITDATA);

    moment().locale('it');
    const params = useParams();

    useEffect(() => {
      if(firstTime)
      {
        getMovie();
      }
      setFirstTime(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firstTime]);
  
    const getMovie = () => {
      SteLib.GetRequest("movies/"+params.id, {}, true).then((data) => {
        setMovie(data)
      });
    }

    const handleResize = () => {
      setWindowInWidth(window.innerWidth)
    }

    let handleTrailerClick = (trailerUrl) => {
      window.open(trailerUrl)
    }  
    
    // create an event listener
    useEffect(() => {
      window.addEventListener("resize", handleResize)
    })

    let onTimeSlotClick = (movie, slot, date) => {
      BP_setData({...BP_data, open: true, movie: movie, slot: slot, date: date});
    }

    if(!loading)
    {
      if (true) {
        return (
          <>
              <Stack sx={{ p: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <img alt="" style={{width: isMobile ? "fit-content" : "28rem", marginRight: isMobile ?"" : "2rem", marginLeft:"auto"}} 
                    src={`data:image/jpeg;base64,${movie.coverImg}`}></img>
                  </Grid>
                  <Grid alignItems="center" item xs={12} sm={6}>
                    <div style={{ width: 
                          windowInWidth >= 1200 && windowInWidth < 1350 ? "75%": 
                          windowInWidth >= 1350 && windowInWidth < 2000 ? "50%": 
                          windowInWidth >= 2000 ? "35%": "100%"}}>
                      {isMobile ? <hr></hr> : <></>}
                      <h2>{movie.title}</h2>
                      <span><b>Durata:</b> <AccessTimeIcon style={accessTimeIconStyle}/> {movie.duration}</span><br/>
                      <span><b>Lingua:</b> {movie.language}</span><br/>
                      <span><b>Data di uscita:</b> {moment(movie.publishedAt).format("DD MMMM YYYY")}</span><br/>
                      <span><b>Genere:</b> {movie.genre}</span><br/><br/>
                      {/*movie.trailer === "" ? <></> : <><span><b>Trailer:</b> <MovieIcon style={movieIconStyle}/> <a target="_blank" href={movie.trailer}>Vedi</a></span><br/></>*/}
                      {movie.trailer === "" ? <></> : <Button variant='outlined' onClick={() => handleTrailerClick(movie.trailer)} style={{width: "50%"}} size="small">Guarda il Trailer</Button>}

                      <h2>Sinossi</h2>
                      <p style={{whiteSpace: "pre-line"}}>{movie.synopsis}</p>

                      <h2>Date e Orari</h2>
                      {(movie.timeTable?.length ?? 0) === 0 ? 
                        <div style={{color: 'darkgray'}}>
                          <b>Nessuna proiezione in programma</b>
                        </div> : <>
                      {movie.timeTable?.map(tt => {
                        return(
                        <>
                          <h4 style={{margin: ".5rem 0"}}>{moment(tt.date).format("dddd DD MMMM YYYY")}</h4>
                          {tt.slots?.map(s => {
                            return(
                              s.bookable === 1 && moment(tt.date + " " + s.time, "YYYY-MM-DD HH:mm:ss") > moment() ? <>
                              <Badge badgeContent={s.availability} max={999} color="secondary" style={{marginRight: "1rem", marginTop: ".75rem"}}>
                                <Chip color="primary" onClick={() => onTimeSlotClick(movie, s, tt.date)} label={<span style={{fontSize: "16px"}}><b>{moment(s.time, "HH:mm:ss").format("HH:mm")}</b></span>}></Chip>
                              </Badge></> :
                              <>
                              <Badge style={{marginRight: "1rem", marginTop: ".25rem"}}>
                                <Chip color="primary" disabled={true} label={<span style={{fontSize: "16px"}}><b>{moment(s.time, "HH:mm:ss").format("HH:mm")}</b></span>}></Chip>
                                </Badge>
                              </>)
                          })}
                        </>)
                      })}
                      {((movie.timeTable?.length ?? 0) > 0 && movie.timeTable.some(t => t.slots?.some(s => s.bookable === 1))) ? 
                      <><br/><br/><small>Premere sull'orario desiderato per procedere alla prenotazione</small></>
                      : <></>}
                      </>}
                    </div>
                  </Grid>
                </Grid>
              </Stack>
              <BookPopup state={{data: BP_data, setData: BP_setData}} successCallback={() => {}}></BookPopup>
            </>
        )
      }
      else
      {
        return (<>hello</>)
      }
    }

}
